import downloadIcon from 'assets/icons/Download-white.svg'
import externalLinkIcon from 'assets/icons/external-link.svg'
import { Button } from 'components/Button'
import { DetailSubsection, TeamInfo } from 'constants/WorkingModePathwaysDetailModals'

export const DetailSubsectionBlock = ({ subsection }: { subsection: DetailSubsection }) => (
  <div className="flex flex-col justify-between gap-4 items-start w-full h-full">
    <div className="flex flex-col gap-2 items-stretch w-full mb-auto">
      <p className="subtitle-xs">{subsection.label}</p>
      {subsection.description && <p className="body-xs w-full">{subsection.description}</p>}
      {subsection.dataSources && (
        <p className="body-xs w-full">
          <span className="font-bold">Data Sources: </span>
          {subsection.dataSources}
        </p>
      )}
      {subsection.bullets && (
        <ul className="pathway-bullets">
          {subsection.bullets.map(bullet => (
            <li key={bullet} className="body-xs">
              {bullet}
            </li>
          ))}
        </ul>
      )}
    </div>
    {(subsection.note || subsection.showDownloadButton) && (
      <div className="flex flex-col gap-4 items-start w-full mt-auto">
        {subsection.note && <p className="body-xs w-full">{subsection.note}</p>}
        {subsection.showDownloadButton &&
          (subsection.downloadUrl ? (
            <a
              href={subsection.downloadUrl}
              target="_blank"
              rel="noreferrer"
              className="btn-black border border-solid body-s font-bold px-[16px] py-[6px] inline-flex items-center gap-2"
            >
              Download guidance
              <img src={downloadIcon} alt="Download" width={16} height={16} />
            </a>
          ) : (
            <Button
              text="Download guidance"
              color="black"
              iconposition="right"
              icon={<img src={downloadIcon} alt="Download" width="16" height="16" />}
              className="px-[16px] py-[6px]"
            />
          ))}
      </div>
    )}
  </div>
)

export const TeamSection = ({ team, bgColor }: { team: TeamInfo; bgColor: string }) => (
  <div
    className="flex flex-col gap-4 items-start p-4 self-stretch rounded-2xl w-full flex-[1_0_0]"
    style={{ backgroundColor: bgColor }}
  >
    <p className="subtitle-xl">Team</p>
    <div className="flex flex-col gap-2 items-start w-full">
      <p className="subtitle-xs">{team.performsRecommendsLabel}</p>
      <p className="body-xs w-full">{team.performsRecommends}</p>
    </div>
    <div className="flex flex-col gap-2 items-start w-full">
      <p className="subtitle-xs">Core Team</p>
      <p className="body-xs w-full">{team.coreTeam}</p>
    </div>
    {team.extendedTeam && (
      <div className="flex flex-col gap-2 items-start w-full">
        <p className="subtitle-xs">Extended Team</p>
        <p className="body-xs w-full">{team.extendedTeam}</p>
      </div>
    )}
  </div>
)

export const SessionToolsSection = ({ bgColor, imgUrl }: { bgColor: string; imgUrl: string }) => (
  <div
    className="flex self-stretch items-center justify-between p-4 rounded-2xl w-full"
    style={{ backgroundColor: bgColor }}
  >
    <div className="flex flex-col gap-4 items-start w-full">
      <p className="title-xs whitespace-nowrap">Session Tools</p>
      <a
        href="https://app.mural.co/t/reborrn0190/m/reborrn0190/1741803875130/917b26cb6886cf897e1b7145046bcdb99e8249d8?sender=u63412ace9107fd7363ca8493"
        target="_blank"
        rel="noreferrer"
        className="btn-black border border-solid body-s font-bold px-[16px] py-[6px] inline-flex items-center gap-2"
      >
        Mural
        <img src={externalLinkIcon} alt="" width={16} height={16} />
      </a>
    </div>
    <div className="flex flex-col gap-4 items-end w-full">
      <img
        src={imgUrl}
        alt=""
        className="w-[76px] h-[76px] aspect-square rounded-[8px] border border-[#FFF] bg-center bg-cover bg-no-repeat"
      />
    </div>
  </div>
)

export const OutputText = ({ text, boldText }: { text: string; boldText?: string }) => {
  if (!boldText) return <p className="body-xs w-full">{text}</p>
  const index = text.indexOf(boldText)
  if (index === -1) return <p className="body-xs w-full">{text}</p>
  return (
    <p className="body-xs w-full">
      {text.slice(0, index)}
      <span className="font-bold">{boldText}</span>
      {text.slice(index + boldText.length)}
    </p>
  )
}

export const StepsList = ({ steps }: { steps: string[] }) => (
  <div className="flex flex-col gap-3 items-start w-full">
    <p className="subtitle-xl">Steps</p>
    <ol className="pathway-steps-list">
      {steps.map((step, index) => (
        <li key={index} className="body-xs">
          {step}
        </li>
      ))}
    </ol>
  </div>
)
